import { Dashboard } from '@app/layouts/dashboard-layout/dashboard'
import { MobileSettings } from '@app/layouts/mobile-settings/mobile-settings'
import { VerifyPage } from '@pages/auth/verify-page'
import { Appointment } from '@pages/teacher/appointment/appointment'
import { ReferralsPage } from '@pages/teacher/referrals-page/referrals'
import { History } from '@pages/teacher/history/history'
import { TeacherHome } from '@pages/teacher/home/home'
import { Messenger } from '@pages/teacher/messenger/messenger'
import { TeacherSettings } from '@pages/teacher/settings/settings'
import { useProfile } from '@shared/api/useProfile'
import React from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import { RedirectsFromDashboard } from './redirects-from-dashboard'
import { Onboarding } from '@pages/teacher/onboarding/onboarding'
import { Information } from '@pages/teacher/information/information'
import { AddCardSuccessPage } from '@pages/teacher/add-card-success-page/add-card-success-page'
import { AddCardFailPage } from '@pages/teacher/add-card-fail-page/add-card-fail-page'
import { PaymentHistory } from '@pages/teacher/payment-history/payment-history'
import { UpdatePassword } from '@pages/settings/update-password/update-password'
import { Notifications } from '@pages/settings/notification-settings/notification'
import { VideoSettings } from '@pages/settings/video-settings/video-settings'
import { SettingsForm } from '@pages/settings/settings-form/settings-form'
import { AppearanceSettings } from '@pages/settings/appearance-settings'
import { useOnboardNeeded } from '@shared/api/useOnboardNeeded'
import { UnsubscribePage } from '@pages/auth/unsubscribe-page'


export const TeacherRouterGroup = () => {
	const {data: profile} = useProfile()
	useOnboardNeeded({
		enabled: !!profile && !profile?.onboarding_passed
	})

	const isFull = () => {
		// return profile?.onboarding_passed || onboard_needed?.onboarding_needed === false
		return profile?.onboarding_passed
	}

	return (
		(process.env?.REACT_APP_ONBOARDING_STATIC_VISIBLE === 'visible' ? false : isFull()) ? 
		<Routes>
			<Route element={<Outlet/>}>
				<Route path="/verify-email/:token" element={<VerifyPage />} />
				<Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
				<Route path="/appointment/:appointmentId" element={<Appointment/>} />
			</Route>
			<Route element={<Dashboard />}>
				<Route path="/" element={<TeacherHome />} />
				<Route path="/messenger" element={<Messenger />}/>
				<Route path="/history" element={<History />} />
				<Route path="/referrals" element={<ReferralsPage />} />
				<Route path="/settings" element={<TeacherSettings />} />
				<Route element={<MobileSettings />}>
					<Route path="/settings/profile" element={<SettingsForm />} />
					<Route path="/settings/video-and-audio" element={<VideoSettings />} />
					<Route path="/settings/notifications" element={<Notifications />} />
					<Route path="/settings/security" element={<UpdatePassword />} />
					<Route path="/settings/appearance" element={<AppearanceSettings />} />
				</Route>
				<Route path="/payment-history" element={<PaymentHistory />} />
				<Route path="/info" element={<Information/>} />
				<Route path="/add-card-success" element={<AddCardSuccessPage/>} />
				<Route path="/add-card-fail" element={<AddCardFailPage/>} />
			</Route>
			<Route path="*" element={<RedirectsFromDashboard/>} />
		</Routes> 
		:
		<Routes>
				<Route path="/" element={<Onboarding/>} />
				<Route path="*" element={<Navigate to={'/'}/>} />
		</Routes>
	)
}
